import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, CartesianGrid, BarChart, Bar, Legend } from "recharts";

const fmtDay = (d) => d.slice(8, 10) + "/" + d.slice(5, 7);
const MONTHS = ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"];
const fmtMonth = (m) => `${MONTHS[parseInt(m.slice(5, 7), 10) - 1]} ${m.slice(2, 4)}`;
const tip = { contentStyle: { borderRadius: 8, border: "1px solid #e4e4e7", fontSize: 12 } };

export const DailyChart = ({ data }) => (
  <div className="h-64" data-testid="daily-chart">
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data} margin={{ left: -20, right: 8, top: 8 }}>
        <defs>
          <linearGradient id="gv" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#C85A32" stopOpacity={0.22} /><stop offset="100%" stopColor="#C85A32" stopOpacity={0} /></linearGradient>
        </defs>
        <CartesianGrid stroke="#f0f0f1" vertical={false} />
        <XAxis dataKey="day" tickFormatter={fmtDay} tick={{ fontSize: 11, fill: "#a1a1aa" }} axisLine={false} tickLine={false} minTickGap={24} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#a1a1aa" }} axisLine={false} tickLine={false} />
        <Tooltip {...tip} labelFormatter={fmtDay} />
        <Area type="monotone" dataKey="views" name="Visite" stroke="#C85A32" strokeWidth={1.6} fill="url(#gv)" />
        <Area type="monotone" dataKey="vcard" name="Download .vcf" stroke="#18181b" strokeWidth={1.2} fill="transparent" />
        <Area type="monotone" dataKey="clicks" name="Click link" stroke="#a1a1aa" strokeWidth={1.2} strokeDasharray="4 3" fill="transparent" />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);

export const MonthlyChart = ({ data }) => (
  <div className="h-64" data-testid="monthly-chart">
    <ResponsiveContainer width="100%" height="100%">
      <BarChart data={data} margin={{ left: -20, right: 8, top: 8 }}>
        <CartesianGrid stroke="#f0f0f1" vertical={false} />
        <XAxis dataKey="month" tickFormatter={fmtMonth} tick={{ fontSize: 11, fill: "#a1a1aa" }} axisLine={false} tickLine={false} />
        <YAxis allowDecimals={false} tick={{ fontSize: 11, fill: "#a1a1aa" }} axisLine={false} tickLine={false} />
        <Tooltip {...tip} labelFormatter={fmtMonth} />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        <Bar dataKey="views" name="Visite" fill="#C85A32" radius={[3, 3, 0, 0]} />
        <Bar dataKey="vcard" name="Download .vcf" fill="#18181b" radius={[3, 3, 0, 0]} />
        <Bar dataKey="clicks" name="Click link" fill="#d4d4d8" radius={[3, 3, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  </div>
);
